import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const TABS = [
  { id: 'networth', label: 'Net Worth', icon: 'DollarSign', field: 'final_net_worth' },
  { id: 'level', label: 'Level', icon: 'Star', field: 'final_level' },
  { id: 'trades', label: 'Trades', icon: 'TrendingUp', field: 'total_trades' },
  { id: 'crimes', label: 'Crimes', icon: 'Skull', field: 'total_crimes' },
  { id: 'wars', label: 'Wars Won', icon: 'Swords', field: 'faction_wars_won' },
];

const TIER_CONFIG = {
  SEASONAL_LEGEND: { label: 'Legend', color: 'text-yellow-400', bg: 'bg-yellow-400/10' },
  SEASONAL_GOLD: { label: 'Gold', color: 'text-yellow-500', bg: 'bg-yellow-500/10' },
  SEASONAL_SILVER: { label: 'Silver', color: 'text-slate-300', bg: 'bg-slate-300/10' },
  SEASONAL_BRONZE: { label: 'Bronze', color: 'text-amber-600', bg: 'bg-amber-600/10' },
};

const formatValue = (field, value) => {
  if (field === 'final_net_worth') return `$${(value / 1000)?.toFixed(1)}K`;
  return value?.toLocaleString() || '0';
};

const SeasonLeaderboard = ({ leaderboard, loading }) => {
  const [activeTab, setActiveTab] = useState('networth');

  const currentTab = TABS?.find(t => t?.id === activeTab);
  const sorted = [...(leaderboard || [])]?.sort((a, b) => (b?.[currentTab?.field] || 0) - (a?.[currentTab?.field] || 0));

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-bold text-foreground flex items-center gap-2">
          <Icon name="Trophy" size={18} className="text-warning" />
          Season Leaderboard
        </h3>
        <span className="text-xs text-muted">{leaderboard?.length || 0} players</span>
      </div>
      {/* Tabs */}
      <div className="flex gap-1 mb-4 overflow-x-auto pb-1">
        {TABS?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-1 px-3 py-1.5 rounded text-xs font-medium whitespace-nowrap transition-colors ${
              activeTab === tab?.id
                ? 'bg-primary text-white' :'bg-surface-700 text-muted hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={12} />
            {tab?.label}
          </button>
        ))}
      </div>
      {loading ? (
        <div className="space-y-2">
          {[...Array(5)]?.map((_, i) => (
            <div key={i} className="h-10 bg-surface-700 rounded animate-pulse" />
          ))}
        </div>
      ) : sorted?.length === 0 ? (
        <div className="text-center py-8 text-muted">
          <Icon name="Trophy" size={32} className="mx-auto mb-2 opacity-30" />
          <p className="text-sm">No leaderboard data yet</p>
        </div>
      ) : (
        <div className="space-y-1">
          {sorted?.slice(0, 20)?.map((entry, idx) => {
            const tier = entry?.reward_tier ? TIER_CONFIG?.[entry?.reward_tier] : null;
            const rankIcon = idx === 0 ? '👑' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : null;
            return (
              <div
                key={entry?.user_id || idx}
                className={`flex items-center gap-3 px-3 py-2 rounded transition-colors hover:bg-surface-700 ${
                  idx < 3 ? 'bg-surface-700/50' : ''
                }`}
              >
                <div className="w-6 text-center">
                  {rankIcon ? (
                    <span className="text-sm">{rankIcon}</span>
                  ) : (
                    <span className="text-xs text-muted font-mono">#{idx + 1}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">
                    {entry?.user_profiles?.username || entry?.username || `Player ${idx + 1}`}
                  </p>
                </div>
                {tier && (
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${tier?.bg} ${tier?.color}`}>
                    {tier?.label}
                  </span>
                )}
                <div className="text-sm font-bold text-primary">
                  {formatValue(currentTab?.field, entry?.[currentTab?.field])}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SeasonLeaderboard;
